export default {
  data() {
    return {
      tables: {
        headers: [
          { text: 'Номер', value: 'id', sortable: false, align: 'left' },
          { text: 'Период', value: 'sold_on_local', sortable: false, align: 'right' },
          { text: 'Состав продажи', value: 'positions', sortable: false, align: 'center', width: '300px' },
          { text: 'Кол-во', value: 'sale_qty', sortable: false, align: 'right' },
          { text: 'Бонусы к зачислению', value: 'bonuses_calc', sortable: false, align: 'right' },
          { text: 'Статус', value: 'status', sortable: false, align: 'center' },
          { text: 'Дистрибьютор', value: 'distributor', sortable: false, align: 'center' },
        ],
        position_headers: [
          { text: 'Артикул', value: 'product.article', sortable: false, align: 'right' },
          { text: 'Кол-во', value: 'quantity', sortable: false, align: 'right' },
          { text: 'Сумма', value: 'cost', sortable: false, align: 'right' },
        ],
      },

      history: [],
      showHistoryID: false,
      editStatuses: [],
      showPhoto: false,
      currentPhoto: null,
      showPdf: false,
      currentPdf: null,
      isLoadPage: false,
      page: 1,
      showTable: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    sales() {
      return this.$store.state.sales.sales;
    },
    loading() {
      return this.$store.state.loading;
    },
    totalCount() {
      return this.$store.state.sales.meta.totalCount;
    },
    pageCount() {
      return this.$store.state.sales.meta.pageCount;
    },
    showActionProgress() {
      return true;
    },
  },
  methods: {
    isEdit(status) {
      return this.editStatuses.indexOf(status) > -1;
    },
    setTableActive(id) {
      if (id === this.showTable) {
        this.showTable = null;
      } else {
        this.showTable = id;
      }
    },
    getSaleQuantity(id) {
      const sale = this.sales.filter(item => item.id === id);
      let quantity = 0;
      if (sale[0].positions) {
        quantity = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.quantity;
          return acc1;
        }, 0);
      }
      return quantity;
    },
    getSaleBonuses(id) {
      const sale = this.sales.filter(item => item.id === id);
      let bonuses = 0;
      if (sale[0].positions) {
        bonuses = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.bonuses_calc;
          return acc1;
        }, 0);
      }
      return bonuses;
    },
    showHistory(id) {
      const sale = this.sales.filter(item => item.id === id);
      this.history = sale.length ? sale[0].history : [];
      this.showHistoryID = (this.showHistoryID !== id) ? id : false;
    },
    getStatusColor(status) {
      switch (status) {
        case 'redo': return 'color-orange';
        case 'draft': return 'color-orange';
        case 'declined': return 'color-red';
        case 'paid': return 'color-green';
        case 'approved': return 'color-green';
        case 'verified': return 'color-green';
        case 'adminReview': return 'color-cyan';
        case 'customerReview': return 'color-blue';
        case 'return': return 'color-cyan';
        case 'return_done': return 'color-orange';
        case 'return_error': return 'color-red';
        case 'return_declined': return 'color-red';
        default: return '';
      }
    },
    getStatusLabel(item) {
      switch (item.status) {
        case 'adminReview': return 'Будет начислено';
        case 'return': return 'Будет возвращено';
        default: return item.status_label;
      }
    },
    getStatusHint(item) {
      switch (item.status) {
        case 'adminReview': return 'Получите после завершения текущей акции';
        default: return '';
      }
    },
    ShowPhoto(photo) {
      this.showPhoto = true;
      this.currentPhoto = { ...photo };
    },
    ClosePhoto() {
      this.showPhoto = false;
      this.currentPhoto = null;
    },
    ShowPdf(photo) {
      this.showPdf = true;
      this.currentPdf = `<iframe src="${photo.url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
    CheckPDF(photo) {
      if (photo.base64) {
        return (photo.base64.indexOf('/pdf;') !== -1);
      }
      if (photo.url) {
        return (photo.url.indexOf('.pdf') !== -1);
      }
      return false;
    },
    ClosePdf() {
      this.showPdf = false;
      this.currentPdf = null;
    },
    async getSales() {
      await this.$store.dispatch('sales/GetSalesList', { profile_id: this.user.profile_id, page: this.page });
    },
  },
  watch: {
    page() {
      this.getSales();
    },
  },
  mounted() {
    // this.$store.dispatch('sales/GetSalesList', { profile_id: this.user.profile_id });
    this.getSales();
  },
};
